import { create } from "zustand";

export const emptyAccountState = {
  error: "",
  info: [],
  loaded: false,
  loading: false,
  logoError: "",
  logoLoading: false,
  logoUrl: "",
  planName: "",
  profile: null,
};

export const emptyUsersState = {
  actionError: "",
  actionLoading: false,
  error: "",
  limits: null,
  loaded: false,
  loading: false,
  roles: [],
  saving: false,
  users: [],
};

export const emptyQuotasState = {
  error: "",
  loaded: false,
  loading: false,
  quotas: null,
};

export const emptySecurityState = {
  error: "",
  loaded: false,
  loading: false,
  mfa: null,
  saving: false,
};

function resolveUpdate(current, updater) {
  return typeof updater === "function" ? updater(current) : updater;
}

function createInitialAccountSettingsState() {
  return {
    accountState: {
      ...emptyAccountState,
      info: [],
    },
    securityState: {
      ...emptySecurityState,
    },
    usersState: {
      ...emptyUsersState,
      roles: [],
      users: [],
    },
    quotasState: {
      ...emptyQuotasState,
    },
  };
}

const useAccountSettingsStore = create((set) => ({
  ...createInitialAccountSettingsState(),

  setAccountState: (updater) =>
    set((state) => ({
      accountState: resolveUpdate(state.accountState, updater),
    })),

  setUsersState: (updater) =>
    set((state) => ({
      usersState: resolveUpdate(state.usersState, updater),
    })),

  setQuotasState: (updater) =>
    set((state) => ({
      quotasState: resolveUpdate(state.quotasState, updater),
    })),

  setSecurityState: (updater) =>
    set((state) => ({
      securityState: resolveUpdate(state.securityState, updater),
    })),

  resetAccountSettingsState: () => set(createInitialAccountSettingsState()),
}));

export default useAccountSettingsStore;
